import { useState } from "react";
import PropTypes from "prop-types";
import Typography from "@shared/v2/Typography";
import DitlCountCardContent from "./DitlCountCardContent";
import { DitlCallButton, DitlPreviewButton } from "./DitlCardButtons";

const DitlUrgentCard = ({
  count = null,
  title,
  collapsedTitle = null,
  description = null,
  mostRecentLabel = null,
  onPreview = null,
  onCall = null,
  onDone = null,
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const toggle = () => setOpen((prev) => !prev);

  if (!open) {
    return (
      <button
        type="button"
        className="tw-flex tw-items-center tw-gap-[8px] tw-w-full tw-h-[52px] tw-px-[16px] tw-py-[8px] tw-rounded-[12px] tw-border-[1px] tw-border-solid tw-border-semantic-blue-25 tw-bg-gradient-to-br tw-from-[var(--semantic-blue-5)] tw-to-[var(--semantic-blue-2_5)] tw-drop-shadow-[0px_2px_4px_rgba(213,213,213,0.5)] tw-text-left tw-cursor-pointer"
        aria-expanded={false}
        onClick={toggle}
      >
        <span className="tw-flex tw-flex-col tw-flex-1 tw-min-w-0 tw-gap-[4px]">
          <Typography variant="subtitle-s" component="span" className="!tw-text-semantic-blue-120">
            {collapsedTitle || title}
          </Typography>
          {mostRecentLabel && (
            <Typography variant="body-s" component="span" className="!tw-italic !tw-text-semantic-blue-120">
              {mostRecentLabel}
            </Typography>
          )}
        </span>
        {count != null && (
          <Typography
            variant="subtitle-m"
            component="span"
            className="tw-w-[24px] tw-text-right !tw-text-semantic-blue-120"
          >
            {count}
          </Typography>
        )}
        <span className="tw-w-[8px] tw-h-[8px] tw-rounded-full tw-bg-semantic-red-50 tw-animate-pulse motion-reduce:tw-animate-none" />
      </button>
    );
  }

  return (
    <DitlCountCardContent
      className="tw-border-[var(--brand-light)]"
      count={count}
      title={title}
      description={description}
      actions={
        <div className="tw-flex tw-items-center tw-gap-[6px]">
          <DitlPreviewButton onClick={onPreview} />
          <DitlCallButton onClick={onCall} />
        </div>
      }
      onToggle={toggle}
      onDone={onDone}
    />
  );
};

DitlUrgentCard.propTypes = {
  count: PropTypes.number,
  title: PropTypes.string.isRequired,
  collapsedTitle: PropTypes.string,
  description: PropTypes.string,
  mostRecentLabel: PropTypes.string,
  onPreview: PropTypes.func,
  onCall: PropTypes.func,
  onDone: PropTypes.func,
  defaultOpen: PropTypes.bool,
};

export default DitlUrgentCard;
